/**
 *
 * CartSummary
 *
 */

import React, { useState } from "react";

import TextField from "@mui/material/TextField";
//import Button from "../../Common/Button";
import { CloseIcon } from "../../Common/Icon";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";
import {
  HANDLE_CART,
  HANDLE_CART_TOTAL,
  HANDLE_CART_QTYTOTAL,
} from "../../../containers/Cart/constants";
import {
  CART_ID,
  CART_TOTAL,
  CART_QTYTOTAL,
  CART_DISCOUNT,
} from "../../../constants";

//import { Container, Row, Col } from 'reactstrap';

const CartSummary = (props) => {
  const {
    cartItems,
    cartTotal,
    cartQtyTotal,
    setcartdiscount,
    cartdiscount,
    //isEditSumm,
    //toggleEditSumm,
    //setCartPrice,
    alltovs,
    dispatch,
  } = props;

  const [isEditSumm, toggleEditSumm] = React.useState(false);

  const handleClose = () => {
    toggleEditSumm(false);
  };

  const setCartPrice = async (e, cart_Items, alltovs, dispatch) => {
    let level_id = e === 1 ? "5" : "4";
    //"1400000001" закупка
    try {
      //const Products = getState().Products?.cartItems;
      let cartItems = cart_Items.map((item) => {
        let tov = alltovs.find((atov) => {
          return item._id === atov.id;
        });
        let price = tov.prices.find((p) => {
          return p.plevelid === level_id;
        });
        item.price = (price?.price || item.price) * 1;
        item.pricediscount = 0;
        item.totalPrice = item.quantity * (item.price - item.pricediscount);
        item.totalPrice = parseFloat(item.totalPrice.toFixed(2));
        return item;
      });

      let total = 0;
      let qtytotal = 0;

      cartItems.map((item) => {
        total += (item.price - (item.pricediscount || 0)) * item.quantity;
        qtytotal += item.quantity;
      });

      total = parseFloat(total.toFixed(2));
      localStorage.setItem(CART_TOTAL, total);
      qtytotal = parseFloat(qtytotal.toFixed(0));
      localStorage.setItem(CART_QTYTOTAL, qtytotal);
      dispatch({
        type: HANDLE_CART_TOTAL,
        payload: total,
      });
      dispatch({
        type: HANDLE_CART_QTYTOTAL,
        payload: qtytotal,
      });

      const cart = {
        cartItems: cartItems,
        cartTotal: total,
        cartQtyTotal: qtytotal,
        cartId: localStorage.getItem(CART_ID),
        cartdiscount: null,
      };

      if (cart?.cartItems != undefined) {
        dispatch({
          type: HANDLE_CART,
          payload: cart,
        });

        //dispatch(calculateCartTotal());

        //dispatch({
        //  type: HANDLE_CART_TOTAL,
        //  payload: total,
        //});
      }

      //await open_process2(params, { ws_client, auth, URL_WS });

      //const response = await axios.post(`${API_URL}/cart/add`, { products });

      //dispatch(setCartId(response.data.cartId));
    } catch (error) {
      console.log(error);
      //handleError(error, dispatch);
    }

    console.log(e);
    //};
  };

  function DContent(props) {
    const {
      bgColor,
      color,
      labelIcon: LabelIcon,
      labelInfo,
      labelText,
      Id,
      parentId,
      level,
      ...other
    } = props;
    return (
      <>
        <div></div>
      </>
    );
  }

  function DContext(props) {
    const {
      bgColor,
      color,
      labelIcon: LabelIcon,
      labelInfo,
      labelText,
      Id,
      parentId,
      level,
      ...other
    } = props;
    return (
      <>
        <div>Проставить цену:</div>
        <Button
          sx={{
            ml: 1,
            alignItems: "center",
            "&:hover": {
              backgroundColor: "primary.light",
              //backgroundColor: 'primary.dark',
              opacity: [0.9, 0.8, 0.7],
            },
          }}
          variant="contained"
          onClick={() => {
            handleClose();
            setcartdiscount(null);
            setCartPrice(1, cartItems, alltovs, dispatch);
          }}
        >
          Опт
        </Button>
        <Button
          sx={{
            ml: 1,
            alignItems: "center",
            "&:hover": {
              backgroundColor: "primary.light",
              //backgroundColor: 'primary.dark',
              opacity: [0.9, 0.8, 0.7],
            },
          }}
          variant="contained"
          onClick={() => {
            handleClose();
            setcartdiscount(null);
            setCartPrice(2, cartItems, alltovs, dispatch);
          }}
        >
          Розн
        </Button>
      </>
    );
  }
  function PaperComponent(props) {
    return (
      <Draggable
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }

  function AlertDialog(props) {
    return (
      <>
        {/* Alert Dialog */}
        <Dialog
          open={isEditSumm}
          //maxWidth={maxWidth}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
          onClose={handleClose}
          PaperProps={{
            component: "form",
            onSubmit: async (event) => {
              event.preventDefault();
              //const formData = new FormData(event.currentTarget);
              //const formJson = Object.fromEntries(formData.entries());
              handleClose();
            },
          }}
        >
          <DialogTitle
            style={{
              fontSize: "1.60rem",
            }}
          >
            {"Изменение цен"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <DContext />
            </DialogContentText>
            <DContent />
          </DialogContent>
          <DialogActions>
            <Button
              sx={{
                ml: 1,
                alignItems: "center",
                "&:hover": {
                  backgroundColor: "primary.light",
                  //backgroundColor: 'primary.dark',
                  opacity: [0.9, 0.8, 0.7],
                },
              }}
              variant="contained"
              onClick={handleClose}
            >
              Cancel
            </Button>
            {/*
            <Button
              sx={{
                ml: 1,
                alignItems: "center",
                "&:hover": {
                  backgroundColor: "primary.light",
                  //backgroundColor: 'primary.dark',
                  opacity: [0.9, 0.8, 0.7],
                },
              }}
              variant="contained"
              type="submit"
            >
              Ok
            </Button>
            */}
          </DialogActions>
        </Dialog>
      </>
    );
  }

  return (
    <div className="cart-summary">
      <div className="container">
        <div className="mb-2 summary-item row">
          <div
            xs="3"
            className="fs-5  price fw-bold col-6"
            //text-right col-6"
          >
            <TextField
              //id="outlined-basic"
              //<span className="fs-5  price fw-bold">{"Скидка   "}</span>
              label="Скидка"
              variant="outlined"
              value={cartdiscount || ""}
              //defaultValue={discount}
              style={{
                marginLeft: -10,
                marginTop: 0,
                //marginBottom: 10,
                width: 70,
              }}
              onChange={(item) => {
                setcartdiscount(item.target.value);
                //setvalue(item.target.value);
              }}
            />
            <span className="fs-5  price fw-bold">{" грн."}</span>
          </div>
          <div xs="3" className="text-right col-1">
            <span className="fs-5  price fw-bold" style={{ marginLeft: -10 }}>
              {cartQtyTotal || 0}
            </span>
          </div>
          <div xs="3" className="text-end col-5">
            <span
              className="fs-5  price fw-bold"
              style={
                {
                  //backgroundColor: isEditSumm ? "red" : "",
                }
              }
              onClick={() => {
                toggleEditSumm(true);
              }}
            >
              {cartTotal - (cartdiscount || 0) + " грн."}
            </span>
          </div>
        </div>
      </div>
      <AlertDialog />
    </div>
  );
};

export default CartSummary;
